/* The Facial Co. theme JS.
   Cart: talks to Shopify's Cart AJAX API (/cart/add.js, /cart/change.js, /cart.js). The cart Shopify
   tracks server-side is the only source of truth; nothing about the cart is stored in the browser.

   Public API (other sections call these; do not rename):
     window.MerCart.addToCart(variantId, quantity[, extra])  -> Promise(item). Throws Error(readable message).
         extra is optional: { selling_plan, properties, open: false }
     window.MerCart.addItems(items[, { open: false }])       -> Promise(response). items = [{ id, quantity, selling_plan, properties }]
     window.MerCart.changeLine(lineKey, quantity)            -> Promise(cart). Throws Error(readable message).
     window.MerCart.getCart()                                -> Promise(cart)
     window.MerCart.refreshDrawer()                          -> Promise(cart)
     window.MerCart.renderSlots()                            -> redraws [data-mer-cart-progress] / [data-mer-cart-addons] outside the drawer
     window.MerCart.openDrawer() / closeDrawer()
     window.MerCart.toast(text[, ms])
     window.MerCart.money(cents)                             -> string in the shop's money format

   Selling settings (free shipping / gift thresholds, add-on products, guarantee days) are printed by
   layout/theme.liquid into <script id="mer-cart-sell">. Every price and saving shown is computed from
   the cart, the product data and those settings; nothing is hard-coded.

   Overlays (only one at a time, site-wide):
     window.MerOverlay.open(name, { el, onClose, modal, lock, focus })
     window.MerOverlay.close([name])
     window.MerOverlay.current   -> name of the open overlay, or null
   Events on document: "mer:overlay" { current }, "mer:cart" { cart } (every redraw),
     "mer:cart:updated" (after every cart change; event.detail is the cart JSON, also at event.detail.cart).

   Rendering uses textContent / createElement for anything that comes from the store or the cart,
   never innerHTML (OWASP DOM based XSS Prevention Cheat Sheet: prefer textContent over innerHTML). */
(function () {
  "use strict";

  var doc = document;
  var root = doc.documentElement;
  var theme = window.MerTheme || {};
  var routes = theme.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $(sel, scope) { return (scope || doc).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || doc).querySelectorAll(sel)); }

  function h(tag, attrs, kids) {
    var el = doc.createElement(tag), k, v;
    for (k in attrs || {}) {
      v = attrs[k];
      if (v == null || v === false) continue;
      if (k === "text") el.textContent = v;
      else if (k === "class") el.className = v;
      else el.setAttribute(k, v === true ? "" : v);
    }
    (kids || []).forEach(function (c) { if (c) el.appendChild(typeof c === "string" ? doc.createTextNode(c) : c); });
    return el;
  }

  function emit(name, detail) {
    try { doc.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) { /* old browser: skip */ }
  }

  function url(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || routes.root || "/";
    if (base.charAt(base.length - 1) !== "/") base += "/";
    return base + path;
  }

  /* ---------- money ---------- */
  var decoder;
  function money(cents) {
    var fmt = theme.moneyFormat || "{{amount}}"; /* no currency symbol is ever assumed */
    var n = Math.round(Number(cents) || 0);
    function f(dec, thou, point) {
      var parts = (Math.abs(n) / 100).toFixed(dec).split(".");
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return (n < 0 ? "-" : "") + int + (parts[1] ? point + parts[1] : "");
    }
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case "amount_no_decimals": return f(0, ",", ".");
        case "amount_with_comma_separator": return f(2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return f(0, ".", ",");
        case "amount_with_apostrophe_separator": return f(2, "'", ".");
        case "amount_no_decimals_with_space_separator": return f(0, " ", ",");
        case "amount_with_space_separator": return f(2, " ", ",");
        case "amount_with_period_and_space_separator": return f(2, " ", ".");
        default: return f(2, ",", ".");
      }
    });
    /* money formats may contain markup or entities; return plain text */
    out = out.replace(/<[^>]*>/g, "");
    if (out.indexOf("&") > -1) {
      decoder = decoder || doc.createElement("textarea");
      decoder.innerHTML = out;
      out = decoder.value;
    }
    return out;
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg, ms) {
    var t = $(".toast");
    if (!t) {
      t = h("div", { class: "toast", role: "status", "aria-live": "polite" });
      doc.body.appendChild(t);
    }
    t.textContent = msg == null ? "" : String(msg);
    t.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("on"); }, ms || 3200);
  }

  /* ---------- overlays: one at a time, scroll lock, focus ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusables(el) {
    return $$(FOCUSABLE, el).filter(function (n) { return n.getClientRects().length > 0; });
  }

  var Overlay = (function () {
    var current = null, entry = null, lastFocus = null;

    function open(name, opts) {
      if (!name || current === name) return;
      var active = doc.activeElement;
      if (current) {
        /* replacing one overlay with another: if focus sits inside the old one, return to its original trigger */
        var keep = entry && entry.el && entry.el.contains(active) ? lastFocus : active;
        close(current, { restore: false });
        lastFocus = keep;
      } else {
        lastFocus = active;
      }
      current = name;
      entry = opts || {};
      var modal = entry.modal !== false;
      if (modal && entry.lock !== false) root.classList.add("mer-lock");
      root.setAttribute("data-mer-overlay", name);
      if (modal && entry.el) {
        var target = entry.focus || entry.el;
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }
      emit("mer:overlay", { current: current });
    }

    function close(name, o) {
      name = name || current;
      if (!name || name !== current) return;
      var was = entry || {};
      current = null; entry = null;
      root.classList.remove("mer-lock");
      root.removeAttribute("data-mer-overlay");
      if (typeof was.onClose === "function") { try { was.onClose(); } catch (e) { /* keep going */ } }
      var restore = !(o && o.restore === false) && was.modal !== false;
      if (restore && lastFocus && doc.contains(lastFocus) && typeof lastFocus.focus === "function") {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
      }
      if (restore) lastFocus = null;
      emit("mer:overlay", { current: null });
    }

    doc.addEventListener("keydown", function (e) {
      if (!current) return;
      if (e.key === "Escape" || e.key === "Esc") { close(); return; }
      if (e.key !== "Tab" || !entry || entry.modal === false || !entry.el) return;
      var list = focusables(entry.el);
      if (!list.length) { e.preventDefault(); entry.el.focus(); return; }
      var first = list[0], last = list[list.length - 1], a = doc.activeElement;
      if (!entry.el.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (a === first || a === entry.el)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });

    return {
      open: open,
      close: close,
      isOpen: function () { return !!current; },
      get current() { return current; }
    };
  })();
  window.MerOverlay = Overlay;

  /* ---------- cart: network ---------- */
  var JSON_HEADERS = { "Content-Type": "application/json", Accept: "application/json" };
  var OFFLINE = "Could not reach the store. Check your connection and try again.";

  function request(path, body, fallback) {
    var opts = body
      ? { method: "POST", headers: JSON_HEADERS, credentials: "same-origin", body: JSON.stringify(body) }
      : { headers: { Accept: "application/json" }, credentials: "same-origin" };
    return fetch(url(path), opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || fallback);
        return data;
      });
    }, function () { throw new Error(OFFLINE); });
  }

  function getCart() { return request("cart.js", null, "Could not load your cart."); }

  /* After any add: pull the fresh cart (redraws the drawer, fires "mer:cart:updated"), then open the
     drawer unless the caller passed { open: false }. The cart page never opens the drawer. */
  function afterAdd(open) {
    return function (res) {
      return refreshDrawer().then(null, function () {}).then(function () {
        if (open && theme.template !== "cart") openDrawer();
        return res;
      });
    };
  }

  function addToCart(id, quantity, extra) {
    var payload, open = !(extra && extra.open === false);
    if (Array.isArray(id)) payload = { items: id };
    else if (id && typeof id === "object") payload = id;
    else {
      payload = { id: id, quantity: Math.max(1, parseInt(quantity, 10) || 1) };
      if (extra && typeof extra === "object") {
        if (extra.selling_plan) payload.selling_plan = extra.selling_plan;
        if (extra.properties) payload.properties = extra.properties;
      }
    }
    return request("cart/add.js", payload, "Could not add that to your cart.").then(afterAdd(open));
  }

  function addItems(items, opts) {
    var list = (Array.isArray(items) ? items : [items]).filter(function (it) { return it && it.id; }).map(function (it) {
      var o = { id: it.id, quantity: Math.max(1, parseInt(it.quantity, 10) || 1) };
      if (it.selling_plan) o.selling_plan = it.selling_plan;
      if (it.properties) o.properties = it.properties;
      return o;
    });
    if (!list.length) return Promise.reject(new Error("Nothing to add."));
    return request("cart/add.js", { items: list }, "Could not add that to your cart.").then(afterAdd(!(opts && opts.open === false)));
  }

  function changeLine(key, quantity) {
    return request("cart/change.js", { id: key, quantity: Math.max(0, parseInt(quantity, 10) || 0) }, "Could not update your cart.").then(commit);
  }

  /* ---------- cart: selling settings (printed by layout/theme.liquid) ---------- */
  var lastCart = null;
  var compareMap = {};   /* variant id -> compare-at price in cents (0 = none) */
  var handleState = {};  /* product handles already looked up */
  var sellCache = null;

  function positive(v) { v = Number(v); return isFinite(v) && v > 0 ? v : 0; }

  function sell() {
    if (sellCache) return sellCache;
    var raw = {}, node = doc.getElementById("mer-cart-sell"), k;
    if (node) { try { raw = JSON.parse(node.textContent) || {}; } catch (e) { raw = {}; } }
    sellCache = {
      ship: positive(raw.ship),
      gift: positive(raw.gift),
      giftLabel: String(raw.giftLabel == null ? "" : raw.giftLabel).trim(),
      days: Math.round(positive(raw.days)),
      currency: raw.currency || "",
      addons: (Array.isArray(raw.addons) ? raw.addons : []).filter(function (a) { return a && a.id && a.variant && a.title; })
    };
    for (k in raw.compare || {}) compareMap[k] = positive(raw.compare[k]);
    sellCache.addons.forEach(function (a) { compareMap[a.variant] = positive(a.compare); });
    return sellCache;
  }

  /* Cart JSON has no compare-at price. Look it up once per product from Shopify's product JSON. */
  function learnCompare(cart) {
    sell();
    cart.items.forEach(function (it) {
      if (compareMap[it.variant_id] != null || !it.handle || handleState[it.handle]) return;
      handleState[it.handle] = 1;
      request("products/" + encodeURIComponent(it.handle) + ".js", null, "").then(function (p) {
        var found = false;
        (p.variants || []).forEach(function (v) {
          compareMap[v.id] = positive(v.compare_at_price);
          if (compareMap[v.id] > v.price) found = true;
        });
        if (found && lastCart) renderDrawer(lastCart);
      }, function () {});
    });
  }

  /* What this line would cost at the highest real reference price: compare-at price, or the one-time
     price when the line is on a subscription plan, or the price before a line discount. */
  function lineOriginal(it) {
    var per = compareMap[it.variant_id] || 0;
    var alloc = it.selling_plan_allocation;
    if (alloc && alloc.compare_at_price > per) per = alloc.compare_at_price;
    return Math.max(it.original_line_price || 0, per * it.quantity);
  }
  function lineFinal(it) { return it.final_line_price != null ? it.final_line_price : it.line_price; }

  function cartSavings(cart) {
    var sum = 0;
    cart.items.forEach(function (it) { sum += Math.max(0, lineOriginal(it) - lineFinal(it)); });
    (cart.cart_level_discount_applications || []).forEach(function (d) { sum += positive(d.total_allocated_amount); });
    return sum;
  }

  /* ---------- cart: progress bar ---------- */
  function milestones() {
    var cfg = sell(), rate = 1, cur = window.Shopify && window.Shopify.currency;
    /* thresholds are typed in the store currency; convert when the shopper sees another one */
    if (cur && cur.rate && cur.active && cfg.currency && cur.active !== cfg.currency) rate = Number(cur.rate) || 1;
    var ship = Math.round(cfg.ship * 100 * rate), gift = Math.round(cfg.gift * 100 * rate);
    var giftText = cfg.giftLabel || "a free gift";
    var list = [];
    if (ship && ship === gift) return [{ at: ship, short: "Free shipping + gift", long: "free shipping and " + giftText }];
    if (ship) list.push({ at: ship, short: "Free shipping", long: "free shipping" });
    if (gift) list.push({ at: gift, short: "Free gift", long: giftText });
    list.sort(function (a, b) { return a.at - b.at; });
    return list;
  }

  var lastPct = 0;
  function renderProgress(el, cart) {
    var list = milestones(), total = cart.total_price || 0;
    if (!list.length || !cart.items.length) { el.hidden = true; return; }
    el.hidden = false;
    el.classList.add("mdr-prog");
    var msg = $(".mdr-prog__msg", el), bar = $(".mdr-prog__bar", el), marks = $(".mdr-prog__marks", el), fill = $(".mdr-prog__fill", el);
    var fresh = !msg || !bar || !marks || !fill;
    if (fresh) {
      el.textContent = "";
      msg = h("p", { class: "mdr-prog__msg", role: "status", "aria-live": "polite" });
      fill = h("span", { class: "mdr-prog__fill" });
      bar = h("div", { class: "mdr-prog__bar", "aria-hidden": "true" }, [fill]);
      marks = h("div", { class: "mdr-prog__marks", "aria-hidden": "true" });
      el.appendChild(msg); el.appendChild(bar); el.appendChild(marks);
    }

    var max = list[list.length - 1].at;
    var got = list.filter(function (m) { return total >= m.at; });
    var next = list[got.length];
    var text = got.length ? "You've got " + got.map(function (m) { return m.long; }).join(" and ") : "";
    if (next) text = (text ? text + ". " : "") + "Add " + money(next.at - total) + " more for " + next.long;
    if (msg.textContent !== text) msg.textContent = text;

    var pct = Math.max(0, Math.min(100, (total / max) * 100));
    if (fresh) { fill.style.width = lastPct + "%"; void fill.offsetWidth; }
    fill.style.width = pct + "%";
    lastPct = pct;
    el.setAttribute("data-pct", String(pct));

    $$(".mdr-prog__tick", bar).forEach(function (n) { bar.removeChild(n); });
    marks.textContent = "";
    list.forEach(function (m, i) {
      var p = (m.at / max) * 100, on = total >= m.at;
      if (i < list.length - 1) bar.appendChild(h("i", { class: "mdr-prog__tick", style: "left:" + p + "%" }));
      marks.appendChild(h("span", {
        class: "mdr-prog__mark" + (on ? " is-on" : "") + (p < 40 ? " is-start" : ""),
        style: "left:" + p + "%",
        text: (on ? "✓ " : "") + m.short
      }));
    });
    el.classList.toggle("is-done", !next);
  }

  /* ---------- cart: "Add to your routine" ---------- */
  function addonCard(a) {
    var price = h("p", { class: "mdr-add__price" }, [h("span", { text: money(a.price) })]);
    if (positive(a.compare) > a.price) {
      price.appendChild(h("span", { class: "sr-only", text: " was " }));
      price.appendChild(h("s", { text: money(a.compare) }));
    }
    return h("li", { class: "mdr-add__card" }, [
      h("div", { class: "mdr-add__img" }, [
        a.image
          ? h("img", { src: a.image, width: "64", height: "64", loading: "lazy", alt: "" })
          : h("i", { "aria-hidden": "true" })
      ]),
      h("div", { class: "mdr-add__info" }, [
        h("a", { class: "mdr-add__name", href: a.url || "#", text: a.title }),
        h("div", { class: "mdr-add__foot" }, [
          price,
          h("button", {
            type: "button", class: "mdr-add__btn", "data-mer-addon": String(a.variant),
            "data-mer-addon-title": a.title, "aria-label": "Add " + a.title + " to cart", text: "Add"
          })
        ])
      ])
    ]);
  }

  function renderAddons(el, cart) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var list = sell().addons.filter(function (a) { return !inCart[a.id]; });
    el.textContent = "";
    if (!list.length || !cart.items.length) { el.hidden = true; return; }
    el.hidden = false;
    el.classList.add("mdr-add");
    el.appendChild(h("h3", { class: "mdr-add__h", text: "Add to your routine" }));
    el.appendChild(h("ul", { class: "mdr-add__row" + (list.length === 1 ? " is-one" : ""), role: "list" }, list.map(addonCard)));
  }

  function addAddon(btn) {
    if (btn.disabled) return;
    var title = btn.getAttribute("data-mer-addon-title") || "Item";
    var inDrawer = !!btn.closest("#mer-drawer");
    btn.disabled = true;
    btn.textContent = "Adding";
    addItems([{ id: Number(btn.getAttribute("data-mer-addon")), quantity: 1 }], { open: false }).then(function () {
      announce(title + " added to your cart.");
      if (!inDrawer) { toast(title + " added to your cart."); return; }
      var d = drawer();
      if (d && Overlay.current === "cart") {
        var target = $("[data-mer-addon]", d) || $('button[name="checkout"]', d) || $(".x", d) || d;
        target.focus();
      }
    }, function (err) {
      btn.disabled = false;
      btn.textContent = "Add";
      toast(err.message, 5000);
      announce(err.message);
    });
  }

  /* Progress bar and add-on row placed outside the drawer (the cart page uses these). */
  function renderSlots() {
    if (!lastCart) return;
    var d = drawer();
    $$("[data-mer-cart-progress]").forEach(function (el) { if (!d || !d.contains(el)) renderProgress(el, lastCart); });
    $$("[data-mer-cart-addons]").forEach(function (el) { if (!d || !d.contains(el)) renderAddons(el, lastCart); });
  }

  /* ---------- cart: drawer ---------- */
  function drawer() { return doc.getElementById("mer-drawer"); }
  function scrim() { return doc.getElementById("mer-overlay"); }

  function cartConfig() {
    var cfg = {}, node = doc.getElementById("mer-cart-config");
    if (node) { try { cfg = JSON.parse(node.textContent) || {}; } catch (e) { cfg = {}; } }
    return {
      title: cfg.title || "Your cart",
      empty: cfg.empty || "Your cart is empty.",
      emptyCta: cfg.emptyCta || "Shop now",
      emptyUrl: cfg.emptyUrl || routes.all || url("collections/all"),
      note: cfg.note || "Shipping and taxes calculated at checkout.",
      reassure: cfg.reassure || "",
      checkout: cfg.checkout || "Checkout"
    };
  }

  function imgUrl(src, width) {
    if (!src) return "";
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set("width", String(width));
      return u.toString();
    } catch (e) { return src; }
  }

  function countLabel(n) { return n === 1 ? "1 item" : n + " items"; }

  function updateCounts(n) {
    $$(".cart-count,[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
    $$("[data-mer-cart-open]").forEach(function (el) { el.setAttribute("aria-label", "Cart, " + countLabel(n)); });
    $$("[data-cart-count-text]").forEach(function (el) { el.textContent = n ? countLabel(n) : ""; });
  }

  function lineNode(it) {
    var title = it.product_title || it.title || "Item";
    var media = h("div", { class: "mdr-img" }, [
      it.image
        ? h("img", { src: imgUrl(it.image, 216), width: "72", height: "72", loading: "lazy", alt: (it.featured_image && it.featured_image.alt) || title })
        : h("i", { "aria-hidden": "true" })
    ]);

    var info = h("div", { class: "mdr-info" }, [h("a", { class: "mdr-name", href: it.url || "#", text: title })]);
    if (it.variant_title && it.variant_title !== "Default Title" && !it.product_has_only_default_variant) {
      info.appendChild(h("p", { class: "mdr-meta", text: it.variant_title }));
    }
    var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
    if (plan && plan.name) info.appendChild(h("p", { class: "mdr-meta mdr-plan", text: plan.name }));
    var props = it.properties || {};
    Object.keys(props).forEach(function (k) {
      if (k.charAt(0) === "_" || props[k] === "" || props[k] == null) return;
      info.appendChild(h("p", { class: "mdr-meta", text: k + ": " + props[k] }));
    });
    (it.line_level_discount_allocations || []).forEach(function (a) {
      var name = a.discount_application && a.discount_application.title;
      if (name) info.appendChild(h("p", { class: "mdr-meta mdr-disc", text: name }));
    });

    info.appendChild(h("div", { class: "mdr-ctl" }, [
      h("div", { class: "mdr-qty", role: "group", "aria-label": "Quantity for " + title }, [
        h("button", { type: "button", "data-mer-act": "dec", "data-mer-key": it.key, "aria-label": "Decrease quantity of " + title, text: "−" }),
        h("span", { "aria-hidden": "true", text: String(it.quantity) }),
        h("button", { type: "button", "data-mer-act": "inc", "data-mer-key": it.key, "aria-label": "Increase quantity of " + title, text: "+" })
      ]),
      h("span", { class: "sr-only", text: "Quantity " + it.quantity }),
      h("button", { type: "button", class: "mdr-rm", "data-mer-act": "rm", "data-mer-key": it.key, "aria-label": "Remove " + title, text: "Remove" })
    ]));

    var finalPrice = lineFinal(it), original = lineOriginal(it);
    var price = h("div", { class: "mdr-price" }, [h("span", { text: money(finalPrice) })]);
    if (original > finalPrice) {
      price.appendChild(h("span", { class: "sr-only", text: " was " }));
      price.appendChild(h("s", { text: money(original) }));
    }

    return h("li", { class: "mdr-line", "data-key": it.key, "data-qty": String(it.quantity) }, [media, info, price]);
  }

  function drawDrawer(d, cart) {
    var body = $("[data-mer-cart-body]", d) || $(".body", d);
    var foot = $("[data-mer-cart-foot]", d) || $("footer", d);
    if (!body) return;
    var cfg = cartConfig(), cartUrl = routes.cart || url("cart");
    var titleEl = $("[data-mer-cart-title]", d);
    if (titleEl) titleEl.textContent = cfg.title;

    var prog = $("[data-mer-cart-progress]", d);
    if (!prog) {
      prog = h("div", { class: "mdr-prog", "data-mer-cart-progress": true, hidden: true });
      body.parentNode.insertBefore(prog, body);
    }
    renderProgress(prog, cart);

    /* remember which control had focus so a re-render does not drop the keyboard user */
    var a = doc.activeElement, token = null;
    if (a && d.contains(a) && a.getAttribute("data-mer-key")) token = { key: a.getAttribute("data-mer-key"), act: a.getAttribute("data-mer-act") };
    var hadFocus = a && d.contains(a) && a !== d;

    body.textContent = "";
    if (foot) foot.textContent = "";

    if (!cart.items.length) {
      body.appendChild(h("div", { class: "mdr-empty" }, [
        h("i", { "aria-hidden": "true" }),
        h("p", { text: cfg.empty }),
        h("a", { class: "btn", href: cfg.emptyUrl, text: cfg.emptyCta })
      ]));
      if (foot) foot.hidden = true;
    } else {
      body.appendChild(h("ul", { class: "mdr-list" }, cart.items.map(lineNode)));
      var addons = h("div", { "data-mer-cart-addons": true, hidden: true });
      body.appendChild(addons);
      renderAddons(addons, cart);

      if (foot) {
        foot.hidden = false;
        var saving = cartSavings(cart), days = sell().days;
        foot.appendChild(h("div", { class: "mdr-row total" }, [h("span", { text: "Subtotal" }), h("span", { text: money(cart.total_price) })]));
        if (saving > 0) {
          foot.appendChild(h("p", { class: "mdr-save" }, [h("span", { text: "You're saving" }), h("b", { text: money(saving) })]));
        }
        /* posting name="checkout" to the cart URL is Shopify's standard way into checkout */
        foot.appendChild(h("form", { action: cartUrl, method: "post", class: "mdr-go" }, [
          h("button", { type: "submit", name: "checkout", class: "btn block", text: cfg.checkout })
        ]));
        foot.appendChild(h("div", { class: "mdr-fine" }, [
          h("span", { text: cfg.note }),
          h("a", { href: cartUrl, text: "View cart" })
        ]));
        if (days > 0) foot.appendChild(h("p", { class: "mdr-guar", text: days + "-day use it or return it guarantee" }));
        else if (cfg.reassure) foot.appendChild(h("p", { class: "mdr-reassure", text: cfg.reassure }));
      }
    }

    if (hadFocus) {
      var next = null;
      if (token) {
        $$("[data-mer-act]", d).forEach(function (n) {
          if (!next && n.getAttribute("data-mer-key") === token.key && n.getAttribute("data-mer-act") === token.act) next = n;
        });
      }
      (next || $(".x", d) || d).focus();
    }
  }

  function renderDrawer(cart) {
    if (!cart || !cart.items) return cart;
    lastCart = cart;
    updateCounts(cart.item_count);
    learnCompare(cart);
    var d = drawer();
    if (d) drawDrawer(d, cart);
    renderSlots();
    emit("mer:cart", { cart: cart });
    return cart;
  }

  /* A real cart change (or the first load): redraw, then tell the rest of the page. */
  function commit(cart) {
    if (!cart || !cart.items) return cart;
    renderDrawer(cart);
    var detail = {}, k;
    for (k in cart) detail[k] = cart[k];
    detail.cart = cart;
    emit("mer:cart:updated", detail);
    return cart;
  }

  function announce(text) {
    var live = $("[data-mer-cart-live]");
    if (live) live.textContent = text;
  }

  function refreshDrawer() {
    return getCart().then(commit);
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    if (Overlay.current === "cart") return;
    if (!lastCart) refreshDrawer().catch(function (e) { toast(e.message, 5000); });
    d.classList.add("on");
    d.setAttribute("aria-hidden", "false");
    if (scrim()) scrim().classList.add("on");
    /* replay the progress fill so the shopper sees it move */
    var prog = $("[data-mer-cart-progress]", d), fill = prog && $(".mdr-prog__fill", prog);
    if (fill && !prog.hidden && !reduceMotion) {
      fill.style.width = "0%";
      void fill.offsetWidth;
      fill.style.width = (prog.getAttribute("data-pct") || "0") + "%";
    }
    Overlay.open("cart", {
      el: d,
      focus: $(".x", d) || d,
      onClose: function () {
        d.classList.remove("on");
        d.setAttribute("aria-hidden", "true");
        if (scrim()) scrim().classList.remove("on");
      }
    });
  }
  function closeDrawer() { Overlay.close("cart"); }

  window.MerCart = {
    addToCart: addToCart, addItems: addItems, changeLine: changeLine, getCart: getCart, refreshDrawer: refreshDrawer,
    renderSlots: renderSlots, openDrawer: openDrawer, closeDrawer: closeDrawer, toast: toast, money: money
  };

  /* ---------- mobile menu ---------- */
  function menu() { return doc.getElementById("mer-menu"); }
  function setMenuButtons(open) {
    $$("[data-mer-menu-open]").forEach(function (b) { b.setAttribute("aria-expanded", open ? "true" : "false"); });
  }
  function openMenu() {
    var m = menu();
    if (!m || Overlay.current === "menu") return;
    m.classList.add("on");
    setMenuButtons(true);
    var panel = $(".mhd-menu-panel", m) || m;
    Overlay.open("menu", {
      el: panel,
      focus: $("[data-mer-menu-close]", panel) || panel,
      onClose: function () { m.classList.remove("on"); setMenuButtons(false); }
    });
  }
  function closeMenu() { Overlay.close("menu"); }

  /* ---------- header: keep the announcement bar out of the sticky area ---------- */
  var annObserver;
  function measureHeader() {
    var wrap = $(".mer-header-wrap");
    if (!wrap) return;
    var ann = $("[data-mer-ann]", wrap);
    var set = function () { wrap.style.setProperty("--mer-ann-h", (ann ? ann.offsetHeight : 0) + "px"); };
    set();
    if (annObserver) annObserver.disconnect();
    if (ann && "ResizeObserver" in window) { annObserver = new ResizeObserver(set); annObserver.observe(ann); }
  }

  /* ---------- shared horizontal scrollers ([data-mer-scroller]) ---------- */
  function initScrollers(scope) {
    $$("[data-mer-scroller]", scope).forEach(function (el) {
      if (el.__merScroller) return;
      el.__merScroller = true;
      if (!el.hasAttribute("tabindex")) el.tabIndex = 0;
      var holder = el.closest("[data-mer-scroller-root]") || el.parentElement;
      var prev = holder && $("[data-mer-prev]", holder), next = holder && $("[data-mer-next]", holder);
      function by(dir) {
        el.scrollBy({ left: dir * Math.max(el.clientWidth * 0.8, 200), behavior: reduceMotion ? "auto" : "smooth" });
      }
      function sync() {
        var max = el.scrollWidth - el.clientWidth - 2;
        if (prev) prev.disabled = el.scrollLeft <= 2;
        if (next) next.disabled = el.scrollLeft >= max;
      }
      if (prev) prev.addEventListener("click", function () { by(-1); });
      if (next) next.addEventListener("click", function () { by(1); });
      el.addEventListener("scroll", sync, { passive: true });
      window.addEventListener("resize", sync, { passive: true });
      sync();
      el.addEventListener("keydown", function (e) {
        if (e.target !== el) return;
        if (e.key === "ArrowRight") { e.preventDefault(); by(1); }
        if (e.key === "ArrowLeft") { e.preventDefault(); by(-1); }
      });
      /* mouse drag only; touch and trackpad use native scrolling */
      var down = false, moved = false, startX = 0, startLeft = 0;
      el.addEventListener("pointerdown", function (e) {
        if (e.pointerType !== "mouse" || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
      });
      window.addEventListener("pointermove", function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) { moved = true; el.classList.add("is-dragging"); }
        if (moved) el.scrollLeft = startLeft - dx;
      });
      window.addEventListener("pointerup", function () {
        if (!down) return;
        down = false;
        el.classList.remove("is-dragging");
      });
      el.addEventListener("click", function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      el.addEventListener("dragstart", function (e) { e.preventDefault(); });
    });
  }

  /* ---------- wiring ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest("[data-mer-menu-open]")) { e.preventDefault(); openMenu(); return; }
    if (t.closest("[data-mer-menu-close]")) { e.preventDefault(); closeMenu(); return; }
    if (t.closest("#mer-menu a")) { closeMenu(); return; } /* let the link navigate */

    var cartBtn = t.closest("[data-mer-cart-open],#mer-cart-btn");
    if (cartBtn) {
      if (theme.template === "cart" || !drawer()) return; /* on the cart page the icon is a plain link */
      e.preventDefault();
      openDrawer();
      return;
    }
    if (t.closest("#mer-overlay,[data-mer-cart-close]")) { e.preventDefault(); closeDrawer(); return; }

    var addon = t.closest("[data-mer-addon]");
    if (addon) { e.preventDefault(); addAddon(addon); return; }

    var act = t.closest("#mer-drawer [data-mer-act]");
    if (act) {
      e.preventDefault();
      var d = drawer();
      if (d.getAttribute("aria-busy") === "true") return;
      var line = act.closest(".mdr-line");
      var qty = parseInt(line && line.getAttribute("data-qty"), 10) || 0;
      var kind = act.getAttribute("data-mer-act");
      var nextQty = kind === "rm" ? 0 : Math.max(0, qty + (kind === "inc" ? 1 : -1));
      d.setAttribute("aria-busy", "true");
      changeLine(act.getAttribute("data-mer-key"), nextQty).then(function (cart) {
        d.removeAttribute("aria-busy");
        announce("Cart updated. " + countLabel(cart.item_count) + ", subtotal " + money(cart.total_price) + ".");
      }, function (err) {
        d.removeAttribute("aria-busy");
        toast(err.message, 5000);
        announce(err.message);
        refreshDrawer().catch(function () {});
      });
    }
  }

  function init() {
    doc.addEventListener("click", onClick);

    /* first paint of the cart comes from the JSON Shopify printed into the page: no extra request */
    var initial = doc.getElementById("mer-cart-initial"), cart = null;
    if (initial) { try { cart = JSON.parse(initial.textContent); } catch (e) { cart = null; } }
    if (cart && cart.items) commit(cart);
    else refreshDrawer().catch(function () {});

    /* a page restored from the back/forward cache can show a stale cart */
    window.addEventListener("pageshow", function (e) { if (e.persisted) refreshDrawer().catch(function () {}); });

    measureHeader();
    initScrollers(doc);

    /* leaving the phone layout closes the phone menu */
    if (window.matchMedia) {
      var mq = window.matchMedia("(min-width: 990px)");
      var onMq = function () { if (mq.matches) closeMenu(); };
      if (mq.addEventListener) mq.addEventListener("change", onMq); else if (mq.addListener) mq.addListener(onMq);
    }

    /* theme editor: sections are re-rendered in place */
    doc.addEventListener("shopify:section:load", function (e) {
      measureHeader();
      initScrollers(e.target);
      if (Overlay.current === "menu" && !menu()) Overlay.close("menu");
      if (lastCart) renderDrawer(lastCart);
    });

    /* after a newsletter sign-up Shopify reloads the page with ?customer_posted=true */
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      var src = $("[data-mer-signup-thanks]");
      toast((src && src.getAttribute("data-mer-signup-thanks")) || "Thanks. You are on the list.", 5000);
    }

    /* legacy: sticky add-to-cart bar used by the older product section */
    var mainAdd = doc.getElementById("pdp-add"), sticky = doc.getElementById("sticky");
    if (mainAdd && sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(mainAdd);
    }
  }

  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", init);
  else init();
})();
